<template>
  <div>
    <FormWizardStepHeader
      title="Select industry"
      description="Choose one or more industries that you invest in"
    />

    <AlertSlideUpDown :show="$v.industries.$error"
      >Please select at least one industry</AlertSlideUpDown
    >

    <div class="search mb-30">
      <i class="icon-search"></i>
      <input v-model="search" placeholder="Search in industry" type="text" />
    </div>

    <FormItem>
      <b-form-checkbox-group
        v-model="form.industries"
        buttons
        class="btn-group-outline-spaced-big mb-20"
        @input="$v.industries.$touch()"
      >
        <b-form-checkbox
          v-for="industry in visibleIndustries"
          :key="industry.value"
          :value="industry.value"
        >
          <span>{{ industry.label }}</span>
        </b-form-checkbox>
      </b-form-checkbox-group>
    </FormItem>

    <SearchNoResults
      v-if="!visibleIndustries.length"
      type="industries"
      :border="false"
    />
  </div>
</template>

<script>
import FormItem from '@/components/form/FormItem'
import FormWizardStepHeader from '@/components/FormWizardStepHeader'
import AlertSlideUpDown from '@/components/AlertSlideUpDown'
import SearchNoResults from '@/components/search/SearchNoResults'

export default {
  name: 'InvestorFormStepIndustry',
  components: {
    AlertSlideUpDown,
    FormItem,
    FormWizardStepHeader,
    SearchNoResults
  },
  props: {
    $v: {
      type: Object,
      required: true
    },
    value: {
      type: Object
    }
  },
  data() {
    return {
      form: {
        ...this.value
      },
      search: ''
    }
  },
  computed: {
    industries() {
      return this.$store.getters['meta/industries']
    },
    visibleIndustries() {
      const search = this.search.toLowerCase()

      return this.industries
        .slice(0)
        .sort((a, b) => (a.label > b.label ? 1 : -1))
        .filter((item) => {
          if (search) {
            return item.label.toLowerCase().indexOf(search) > -1
          }

          return true
        })
    }
  },
  watch: {
    value(newValue) {
      this.form = newValue
    },
    form: {
      deep: true,
      handler() {
        this.$emit('input', this.form)
        this.search = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;
  padding: 0;
  max-width: 320px;
  border: 1px solid #ced0d5;
  background-color: #fff;

  i {
    width: 50px;
    text-align: center;
    opacity: 0.5;
  }

  input {
    border: 0;
    flex: 1 1 auto;
    height: 100%;
    outline: none;
    height: calc(1em + 2.4rem + 2px);
    padding: 0;
  }
}
</style>
